export const VARIANT_ID_ATTRIBUTE = 'data-widget-variant-id';
